import { render, staticRenderFns } from "./DetailMaintain.vue?vue&type=template&id=32587618&scoped=true&"
import script from "./DetailMaintain.vue?vue&type=script&lang=ts&"
export * from "./DetailMaintain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32587618",
  null
  
)

export default component.exports